var map = {
	"./c9.png": "JtzT",
	"./c9_icon.png": "w2g/",
	"./dongle.png": "X9HP",
	"./dongle_icon.png": "F6JH",
	"./fastbi.png": "59YL",
	"./fastbi_icon.png": "X2XT",
	"./fastbi_suit.png": "GiVC",
	"./home-menu.png": "9ctl",
	"./menu_icon01.png": "xZYP",
	"./menu_icon02.png": "msv3",
	"./menu_icon03.png": "m0dZ",
	"./menu_icon04.png": "Cfy/",
	"./menu_icon05.png": "y3pa",
	"./older/menu_icon01.png": "hCbR",
	"./older/menu_icon02.png": "pxP+",
	"./older/menu_icon03.png": "r/JO",
	"./older/menu_icon04.png": "zq1X",
	"./service.png": "XNwe",
	"./service_icon.png": "UcHP",
	"./suit_icon.png": "efHW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KPfu";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home ^\.\/.*$
// module id = KPfu
// module chunks = 1